export const CHANGE_REVERB_SECONDS_TO_AMOUNT = "CHANGE_REVERB_SECONDS_TO_AMOUNT";
export const CHANGE_REVERB_DECAY_TO_AMOUNT = "CHANGE_REVERB_DECAY_TO_AMOUNT";